var masks = document.querySelectorAll('.main__wrap .wp-block-cover.is-style-mask');

masks.forEach((mask) => {
    var mediaImage = mask.querySelectorAll('.wp-block-cover__inner-container > .wp-block-media-text.is-style-mask');
    if(mediaImage.length == 0) {
        mask.classList.add('cover-no-image');
    }
});
